import script from "./HomePageHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePageHero.vue?vue&type=script&lang=ts&setup=true"

import "./HomePageHero.vue?vue&type=style&index=0&id=ca9175f4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca9175f4"]])

export default __exports__